"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var components_1 = require("../../shared/core/components");
var analytics_subjects_1 = require("./analytics-subjects");
var FormattedAmount_1 = require("./components/FormattedAmount/FormattedAmount");
function ContactUsLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var contactUs = (0, core_1.useLinks)().contactUs;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CONTACT_US_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: contactUs() }, children)));
}
function PrivacyPolicyLink(_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var privacyPolicy = (0, core_1.useLinks)().privacyPolicy;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.PRIVACY_POLICY_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: privacyPolicy() }, children)));
}
function HowWeUseYourDataLink(_a) {
    var _b;
    var children = _a.children;
    var Small = (0, core_1.useComponents)().Small;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.HOW_WE_USE_YOUR_DATA_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(Small, null, children)));
}
var UnderstandingYourBalanceLink = function (_a) {
    var _b;
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var understandingYourBalance = (0, core_1.useLinks)().understandingYourBalance;
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.UNDERSTAND_YOUR_BALANCE_LINK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(TextLink, { href: understandingYourBalance(), opensInNewWindow: true }, children)));
};
function Balance(_a) {
    var balance = _a.balance;
    return react_1.default.createElement(FormattedAmount_1.FormattedAmount, { fontSize: 6, amount: balance });
}
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        profile: {
            accountHeading: 'Your account details',
            profileHeading: 'Profile',
            emailLabel: 'Email',
            confirmEmailLabel: 'Confirm email',
            accountNumberLabel: 'Account Number',
            nameLabel: 'Name',
            passwordLabel: 'Password',
            resetPasswordLabel: 'Reset password',
            phoneLabel: 'Phone',
            phoneNumberLabel: 'phone number',
            editEmailLinkLabel: 'Edit email',
            editPhoneLinkLabel: 'Edit phone',
            backtoProfile: 'Back to profile',
            editAccountEmailHeading: 'Edit email',
            editAccountPhoneHeading: 'Edit phone',
            editMarketingPreferencesHeading: 'Edit marketing contact preferences',
            editMarketingPreferencesIntro: '<P>We may get in touch from time to time to tell you about offers, events and more.</P>',
            editMarketingPreferencesLoadingText: '<P>Saving your preferences...</P>',
            editMarketingPreferencesOptionsGroupLabel: 'We may occasionally contact you about promotions and exciting news about $t(common.retailer):',
            dummyPassword: '●●●●●●●●●●',
            save: 'Save changes',
            telAutocomplete: 'tel',
            emailAutocomplete: 'email',
            privacyPolicyInfo: '<P><Small>Please see our <PrivacyPolicyLink><Strong>privacy policy</Strong></PrivacyPolicyLink> for further details.</Small></P>',
            howWeUseDataToggleLabel: '<HowWeUseYourDataLink>How we use your data</HowWeUseYourDataLink>',
            howWeUseDataInfo: "\n      <P>\n      <Small>\n        We'll never sell any of your data or details to anyone. We\n        may use your data to create reports or profiles for analytics\n        and marketing purposes, and via online advertising tools such as\n        ValueClick and Google Analytics.\n      </Small>\n    </P>\n    <P>\n      <Small>\n        We may contact you for up to a year after you have left us. You\n        can change your preferences at any time.\n      </Small>\n    </P>",
            addressLabel: 'Your address',
            moveOutLabel: "<P>You told us that you\u2019re moving out on the {{moveOutDate}}. If this is incorrect or\n                      your moving date has changed <ContactUsLink>contact us</ContactUsLink>.</P>",
            updateError: "<P>Sorry, we were not able to update your details, please try again.</P>",
            moveOutCTALabel: "Tell us you're moving out",
            marketingHeading: 'Marketing contact preferences',
            changePreferences: 'Change preferences',
            checkEmailAddress: 'Check the email you have entered and try again',
            checkPhoneNumber: 'Check the number you entered is correct and try again',
            emailMustMatch: "Emails have to match",
            marketingNoContact: '<P>You have chosen not to be contacted about marketing by <NoWrap>$t(common.retailer)</NoWrap>.</P>',
            marketingPromotion: '<P>We may occasionally contact you about promotions and exciting news about <NoWrap>$t(common.retailer)</NoWrap> by:</P>',
            verify: '<Strong>Please verify your new email address using the link we have sent to your inbox.</Strong>',
            summaryHeading: "Today's balance",
            summaryVariant1: '<P>This reflects charges and payments since your last bill.</P>',
            summaryVariant2: '<P>This reflects charges and payments since your last billing period, which ended on {{date}} with a balance of <Strong>{{amount}}{{debitOrCredit}}</Strong>.</P>',
            summaryUnderstandingYourBalance: '<P><UnderstandingYourBalanceLink>Understanding your balance</UnderstandingYourBalanceLink></P>',
            summaryAccountNumberLabel: 'Account number:',
            summaryManageYourPaymentsLinkText: 'Make a payment',
            summaryAccountBalance: '<Balance />{{debitOrCredit}}',
            testString: "I'm not used anywhere, I'm just here for testing",
        },
    },
});
var defaultOptions = {
    defaultTranslations: defaultTranslations,
    components: {
        ContactUsLink: ContactUsLink,
        NoWrap: components_1.NoWrap,
        PrivacyPolicyLink: PrivacyPolicyLink,
        HowWeUseYourDataLink: HowWeUseYourDataLink,
        UnderstandingYourBalanceLink: UnderstandingYourBalanceLink,
        Balance: Balance,
    },
};
exports.defaultOptions = defaultOptions;
